module.exports = __webpack_public_path__ + "img/0220805141155.37382d98.jpg";